import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import useTranslations from "@hooks/useTranslations";
import cn from "classnames";
import { useState } from "react";
import { MdList, MdOutlineGridView } from "react-icons/md";
const ViewSelector = ({ defaultValue = "grid", onClick }) => {
    const [selectedView, setSelectedView] = useState(defaultValue);
    const { t } = useTranslations();
    const handleClick = (view) => {
        setSelectedView(view);
        onClick(view);
    };
    return (_jsxs("div", { className: "view-selector__container", children: [_jsxs("p", { className: "view-selector__label", children: [t("BDO.LiveSite.SearchPage.View"), ":"] }), _jsx("a", { role: "button", className: cn({ "view-selector__option--active": selectedView === "list" }, "view-selector__option"), onClick: () => handleClick("list"), children: _jsx(MdList, { className: "h-6 w-6 text-cta-blue" }) }), _jsx("a", { role: "button", className: cn({ "view-selector__option--active": selectedView === "grid" }, "view-selector__option"), onClick: () => handleClick("grid"), children: _jsx(MdOutlineGridView, { className: "h-6 w-6 text-cta-blue" }) })] }));
};
export default ViewSelector;
